// Blueprint / manifest background — faint measurement grid + guide lines.
// No space, no globe, no particles. Pure structural blueprint.
export const BlueprintBg = () => {
  return (
    <div className="pointer-events-none fixed inset-0 -z-10" aria-hidden="true">
      {/* base color */}
      <div className="absolute inset-0" style={{ background: "var(--xp-bg)" }} />
      {/* measurement grid */}
      <div className="absolute inset-0 bp-grid-bg opacity-70" />
      {/* vertical guide lines (blueprint margins) */}
      <div
        className="absolute inset-y-0 left-[8%] w-px hidden md:block"
        style={{ background: "var(--xp-grid-strong)", opacity: 0.6 }}
      />
      <div
        className="absolute inset-y-0 right-[8%] w-px hidden md:block"
        style={{ background: "var(--xp-grid-strong)", opacity: 0.6 }}
      />
      {/* faint accent wash top-right */}
      <div
        className="absolute right-0 top-0 h-[40vh] w-[40vw]"
        style={{
          background:
            "radial-gradient(circle at 100% 0%, color-mix(in srgb, var(--xp-accent) 14%, transparent), transparent 60%)",
        }}
      />
    </div>
  );
};

// Corner registration mark (crosshair) used to frame sections like a print sheet.
export const RegMark = ({ className = "" }) => (
  <span
    className={`pointer-events-none absolute h-3 w-3 ${className}`}
    aria-hidden="true"
  >
    <span
      className="absolute left-1/2 top-0 h-full w-px -translate-x-1/2"
      style={{ background: "var(--xp-accent)" }}
    />
    <span
      className="absolute top-1/2 left-0 w-full h-px -translate-y-1/2"
      style={{ background: "var(--xp-accent)" }}
    />
  </span>
);
